import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn, ShieldOff } from 'lucide-react';
import { useSession } from '../providers/AuthProvider';

export function SessionExpiryModal() {
  const { sessionExpired, clearSessionExpired } = useSession();
  const navigate = useNavigate();

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (sessionExpired) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [sessionExpired]);

  if (!sessionExpired) return null;

  const handleLogin = () => {
    clearSessionExpired();
    navigate('/login', { replace: true });
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="session-expiry-title"
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />

      {/* Card */}
      <div className="relative w-full max-w-sm rounded-2xl border border-app-border bg-app-surface shadow-2xl p-6 space-y-5">
        {/* Icon */}
        <div className="flex justify-center">
          <div className="rounded-full bg-app-warning-bg p-3">
            <ShieldOff className="h-7 w-7 text-app-warning-text" aria-hidden />
          </div>
        </div>

        {/* Text */}
        <div className="text-center space-y-2">
          <h2
            id="session-expiry-title"
            className="text-lg font-semibold text-app-text"
          >
            Din session er udløbet
          </h2>
          <p className="text-sm text-app-text-secondary">
            Log venligst ind igen for at fortsætte.
          </p>
        </div>

        {/* CTA */}
        <button
          onClick={handleLogin}
          className="w-full flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-app-primary text-sm font-semibold text-app-primary-text hover:bg-app-primary/90 transition touch-manipulation min-h-[48px]"
        >
          <LogIn className="h-4 w-4" aria-hidden />
          Log ind igen
        </button>
      </div>
    </div>
  );
}
